import axios from 'axios';
import Vue from 'vue';

const state = {
    all: [],
    contents: {},
    collapsed: [],
    active: null,
    loaded: false
};

let prior = null;

function mark(state, contents, previous = null){
    for(const chapter of contents){
        Vue.set(state.contents, chapter.chapter_id, chapter);

        if(['unit', 'section'].includes(chapter.chapter_type)){
            mark(state, chapter.chapter_children, previous);
        }else{
            //Don't show exercises here.
            if(chapter.chapter_questions === 0){
                if(previous){
                    Vue.set(previous, 'next', chapter);
                }

                previous = chapter;

                if(prior){
                    Vue.set(chapter, 'previous', prior);
                }

                prior = chapter;
            }
        }
    }
}

const mutations = {
    load(state, products){
        while(state.all.length){
            state.all.pop();
        }

        for(const product of products){
            state.all.push(product);
        }

        //Load any collapsed chapter IDs out of localStorage
        const collapsed = localStorage.getItem('starry-night-collapsed-chapters');

        if(collapsed){
            state.collapsed.push(...collapsed.split(','));
        }

        state.loaded = true;
    },
    add(state, product){
        state.all.push(product);
    },
    remove(state, product){
        state.all.splice(state.all.indexOf(product), 1);

        if(state.active === product){
            state.active = null;
        }
    },
    activate(state, product){
        if(product){
            state.active = product;
        }else{
            state.active = state.all.length ? state.all[0] : null;
        }
    },
    clear(state){
        this.all = [];
        this.active = null;
    },
    contents(state, contents){
        Vue.set(state.active, 'product_contents', contents);

        //Reset `prior` just in case.
        prior = null;

        mark(state, state.active.product_contents);
    },
    toggle(state, node){
        if(state.collapsed.includes(node)){
            state.collapsed.splice(state.collapsed.indexOf(node), 1);
        }else{
            state.collapsed.push(node);
        }

        localStorage.setItem('starry-night-collapsed-chapters', state.collapsed);
    }
};

const actions = {
    load({commit, dispatch, state}){
        if(state.loaded){
            return Promise.resolve();
        }

        return axios.get('/products')
        .then(response => commit('load', response.$data))
        .catch(error => console.log(error));
    },
    add({commit}, product){
        commit('add', product);
    },
    remove({commit, state}, product){
        commit('remove', product);
    },
    activate({commit, state}, product){
        if(state.active && state.active.product_id === product.product_id){
            return;
        }

        commit('activate', product);
    },
    clear({commit}){
        commit('clear');
    },
    contents({commit, state}){
        if(state.active.product_contents){
            return;
        }

        return axios.get(`/products/${state.active.product_id}/chapters`)
        .then(response => commit('contents', response.$data));
    },
    toggle({commit, state}, node){
        commit('toggle', node);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
